<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .items {
    // only add gap for small size
    &.small {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(8px);
    }
  }

  .item {
    @include colors.color(textGrey);
    display: flex;
    gap: utils.in_rem(8px);

    > .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: utils.in_rem(12px);
      height: utils.in_rem(12px);
      padding: 0;
    }

    > .tags {
      display: flex;
      align-items: center;
      align-content: center;
      gap: 4px;
      flex: 1 0 0;
      flex-wrap: wrap;
    }

    > span {
      &.small {
        @include mixins.body4-badge();
        text-align: left;
      }

      &.normal {
        @include mixins.body2();
      }
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";
  import TruncatedText from "@sourcewhale/shared/svelte-design-system/components/utils/TruncatedText.svelte";

  export let item; // article, job or funding item
  export let MAP; // contains keys and corresponding icons and tooltips to be shown
  export let size = "normal"; // small or normal mixins above

  // Only attempt to truncate the following keys (which correspond to lists of items)
  // otherwise show all text
  const KEYS_TO_TRUNCATE = ["industries", "contractTypes"];

  const MAX_TAGS_TO_SHOW = 3;
</script>

{#if item}
  <div class="items {size}">
    {#each Object.keys(MAP) as key}
      <!-- Don't show the key if it is an empty array -->
      {#if item[key] && (Array.isArray(item[key]) ? item[key].length : item[key])}
        <div class="item">
          <!-- Icons -->
          <!-- Don't use IconScale for small size as we don't want the padding it adds -->
          {#if size === "small"}
            <div class="icon">
              <Icon class={MAP[key].icon} {size} placement="left">
                <span slot="tooltip">{MAP[key].tooltip}</span>
              </Icon>
            </div>
          {:else}
            <IconScale class={MAP[key].icon} size="small" placement="left">
              <span slot="tooltip">{MAP[key].tooltip}</span>
            </IconScale>
          {/if}

          {#if key === "tags"}
            <!-- Tags -->
            <div class="tags">
              {#each item.tags.slice(0, MAX_TAGS_TO_SHOW) as tag}
                <StatusTag kind="neutral" contrast="low" size="small">
                  {tag}
                </StatusTag>
              {/each}
              {#if item.tags.length > MAX_TAGS_TO_SHOW}
                <StatusTag kind="neutral" contrast="low" size="small">
                  +{item.tags.length - MAX_TAGS_TO_SHOW}
                </StatusTag>
              {/if}
            </div>
          {:else if KEYS_TO_TRUNCATE.includes(key)}
            <!-- Lists from arrays -->
            <span class={size}>
              <TruncatedText text={item[key]} limit="50" />
            </span>
          {:else}
            <!-- All other keys -->
            <span class={size}>{item[key]}</span>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
{/if}
